import { queryOptions, skipToken } from '@tanstack/react-query';

import { getSummary } from './api';

export const summaryQueries = {
  all: (pharmacyId: string | undefined) => ['summary', pharmacyId] as const,
  detail: (pharmacyId: string | undefined) =>
    queryOptions({
      queryKey: summaryQueries.all(pharmacyId),
      queryFn: pharmacyId ? () => getSummary(pharmacyId) : skipToken,
    }),
};
